import type { PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkBreaks from 'remark-breaks';

export function Markdown({
  allowLinks = true,
  className,
  children,
}: {
  allowLinks?: boolean;
  className?: string;
} & PropsWithChildren) {
  return (
    <ReactMarkdown
      allowedElements={
        allowLinks
          ? ['a', 'ul', 'ol', 'li', 'em', 'br', 'strong', 'b', 'p']
          : ['ul', 'ol', 'li', 'em', 'br', 'strong', 'b', 'p']
      }
      className={className}
      rehypePlugins={[rehypeRaw, rehypeSanitize]}
      remarkPlugins={[remarkBreaks]}
    >
      {children as string}
    </ReactMarkdown>
  );
}
